module.exports = __webpack_public_path__ + "4c4f893c0122c42c2359d3cec4530fa2.MP3";